export async function getAPI(path = `/`, responseType = 'json') {
    const x = await fetch(path);
    if (!x.ok) throw new Error(x.status + ' - ' + x.statusText);
    switch (responseType) {
        case 'text': return await x.text();
        case 'json': return await x.json();
        case 'blob': return await x.blob();
        default: return await x.text();
    }
}